import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { view, lensPath } from 'ramda';
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { v4 as uuidV4 } from 'uuid';
import moment from 'moment';
import entityComposition from '../common/classes/entityComposition';
import SinglePicker from '../common/controls/singlePicker';
class AddReportModal extends Component {
  constructor(props) {
    super(props);
    this.handleAdd = this.handleAdd.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.state = {
      selectedJob: null,
      selectedReportType: null
    };
  }

  /**
   *  Only load jobs and report types when the component is shown
   */
  componentDidMount() {
    const {
      reportTypeIndexQuery,
      reportTypeActions
    } = this.props;
    // requery server each time we mount.
    reportTypeActions.serverFilter({}, reportTypeIndexQuery);
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      reportTypeActions,
      reportTypeIndexQuery
    } = this.props;
    const {
      selectedReportType
    } = this.state;

    // Current requirements state that we must
    // show all report types if a job has no reports
    // associated to it
    if (nextProps.reportTypes.length === 0 && !nextProps.reportTypeLoading) {
      reportTypeActions.serverFilter({}, reportTypeIndexQuery);
      return;
    }
    if (!selectedReportType || nextProps.reportTypeLoading) {
      return;
    }
    const shouldClear = !nextProps.reportTypes.some(rt => rt.id === selectedReportType.id);
    if (shouldClear) {
      this.setState({
        selectedReportType: null
      });
    }
  }
  handleAdd() {
    const {
      selectedJob,
      selectedReportType
    } = this.state;
    const {
      geolocation,
      reportActions,
      notificationActions
    } = this.props;
    const notificationID = 'add-report-error';
    if (!selectedJob || !selectedReportType) {
      notificationActions.error({
        message: 'Both job and report type are required.',
        id: notificationID
      });
    } else {
      notificationActions.dismiss(notificationID);
      reportActions.create(uuidV4().toUpperCase(), moment().utc().toISOString(), geolocation, selectedJob.id, selectedReportType);
    }
  }
  handleSelect(selected) {
    const {
      reportTypeActions,
      reportTypeIndexQuery
    } = this.props;
    // Handle clear
    if (selected === null) {
      this.setState({
        selectedJob: null,
        selectedReportType: null
      });
      reportTypeActions.serverFilter({}, reportTypeIndexQuery);
      return;
    }
    const jobSelected = typeof selected.identifier === 'undefined';
    // report type has an identifier field
    if (jobSelected) {
      reportTypeActions.serverFilter({
        jobReportType: [selected]
      }, reportTypeIndexQuery);
      this.setState({
        selectedJob: selected
      });
    } else {
      this.setState({
        selectedReportType: selected
      });
    }
  }
  render() {
    const {
      reportTypes,
      jobs,
      onHide,
      jobFilterAdd,
      jobFilterAddActions,
      reportLoading
    } = this.props;
    const {
      selectedJob,
      selectedReportType
    } = this.state;
    const isInitialized = view(lensPath(['indexQuery', 'initialized']))(jobFilterAdd);
    const isFiltering = view(lensPath(['indexQuery', 'filters', 'text']))(jobFilterAdd);
    const disabled = !(selectedJob && selectedReportType && !reportLoading);
    return /*#__PURE__*/React.createElement(Modal, {
      isOpen: true,
      toggle: onHide
    }, /*#__PURE__*/React.createElement(ModalHeader, null, "Add Report"), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      sm: 5
    }, /*#__PURE__*/React.createElement("h5", null, "Job"), jobs.length > 0 || !isInitialized || isFiltering ? /*#__PURE__*/React.createElement(SinglePicker, {
      id: "add-select-job",
      labelKey: "jobNumber",
      className: "t-s-job-number",
      options: jobs,
      entity: jobFilterAdd,
      entityActions: jobFilterAddActions,
      onChange: this.handleSelect,
      placeholder: "Required",
      value: selectedJob
    }) : /*#__PURE__*/React.createElement("div", null, "You must add a job before creating a report.")), /*#__PURE__*/React.createElement(Col, {
      sm: 7
    }, /*#__PURE__*/React.createElement("h5", null, "Report Type"), /*#__PURE__*/React.createElement(SinglePicker, {
      id: "add-select-reportType",
      labelKey: "name",
      className: "t-s-report-type",
      options: reportTypes,
      onChange: this.handleSelect,
      placeholder: "Required",
      value: selectedReportType
    })))), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      className: "t-button-add",
      disabled: disabled,
      onClick: this.handleAdd
    }, "Add"), /*#__PURE__*/React.createElement(Button, {
      className: "t-button-cancel",
      onClick: onHide
    }, "Cancel")));
  }
}
AddReportModal.propTypes = {
  jobActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  jobIndexQuery: PropTypes.shape({
    initialized: PropTypes.bool
  }).isRequired,
  jobs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onHide: PropTypes.func.isRequired,
  jobFilterAdd: PropTypes.shape({}).isRequired,
  jobFilterAddActions: PropTypes.shape({}).isRequired,
  reportActions: PropTypes.shape({
    change: PropTypes.func,
    create: PropTypes.func
  }).isRequired,
  reportLoading: PropTypes.bool.isRequired,
  reportTypeActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired,
  reportTypeIndexQuery: PropTypes.shape({
    initialized: PropTypes.bool
  }).isRequired,
  reportTypeLoading: PropTypes.bool.isRequired,
  reportTypes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  geolocation: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number
  }).isRequired,
  notificationActions: PropTypes.shape({
    error: PropTypes.func,
    dismiss: PropTypes.func
  }).isRequired
};
export { AddReportModal as TestAddReportModal };
export default entityComposition(AddReportModal, ['jobFilterAdd'], {
  reportLoading: state => state.report.loading
}, ['notification']);